const css = `._tooltipWrapper_5d3yu_1 {
  border-bottom: 1px dotted var(--text-color);
  cursor: default;
  display: inline-block;
  position: relative;
  width: fit-content;
}
._tooltipWrapper_5d3yu_1 ._tooltip_5d3yu_1 {
  background-color: var(--border-color);
  border-radius: 4px;
  color: var(--text-color);
  display: none;
  font-size: 16px;
  padding: 12px;
  position: absolute; /* Change to absolute positioning */
  text-align: center;
  z-index: 1;
}
@media (min-width: 768px) {
  ._tooltipWrapper_5d3yu_1 ._tooltip_5d3yu_1 {
    white-space: nowrap;
  }
}
._tooltipWrapper_5d3yu_1 ._tooltip_5d3yu_1::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}
._tooltipWrapper_5d3yu_1 ._tooltipTop_5d3yu_31 {
  top: -12px; /* Position above */
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
}
._tooltipWrapper_5d3yu_1 ._tooltipTop_5d3yu_31::before {
  border-width: 8px 8px 0;
  border-color: var(--border-color) transparent transparent transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}
._tooltipWrapper_5d3yu_1 ._tooltipBottom_5d3yu_43 {
  bottom: -12px; /* Position to the right */
  left: 50%;
  transform: translateX(-50%) translateY(100%);
}
._tooltipWrapper_5d3yu_1 ._tooltipBottom_5d3yu_43::before {
  border-width: 0 8px 8px;
  border-color: transparent transparent var(--border-color) transparent;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}
._tooltipWrapper_5d3yu_1 ._tooltipLeft_5d3yu_55 {
  top: 50%;
  left: -12px; /* Position to the right */
  transform: translateY(-50%) translateX(-100%);
}
._tooltipWrapper_5d3yu_1 ._tooltipLeft_5d3yu_55::before {
  border-width: 8px 0 8px 8px;
  border-color: transparent transparent transparent var(--border-color);
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
}
._tooltipWrapper_5d3yu_1 ._tooltipRight_5d3yu_67 {
  top: 50%;
  right: -12px; /* Position to the right */
  transform: translateY(-50%) translateX(100%);
}
._tooltipWrapper_5d3yu_1 ._tooltipRight_5d3yu_67::before {
  border-width: 8px 8px 8px 0;
  border-color: transparent var(--border-color) transparent transparent;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
}
._tooltipWrapper_5d3yu_1:hover ._tooltip_5d3yu_1 {
  display: block;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "tooltipWrapper": "_tooltipWrapper_5d3yu_1",
  "tooltip": "_tooltip_5d3yu_1",
  "tooltipTop": "_tooltipTop_5d3yu_31",
  "tooltipBottom": "_tooltipBottom_5d3yu_43",
  "tooltipLeft": "_tooltipLeft_5d3yu_55",
  "tooltipRight": "_tooltipRight_5d3yu_67"
};